'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reduxFormPropFilter = require('../../helpers/reduxFormPropFilter');

var _reduxFormPropFilter2 = _interopRequireDefault(_reduxFormPropFilter);

var _onChangeHookGenerator = require('../../helpers/onChangeHookGenerator');

var _onChangeHookGenerator2 = _interopRequireDefault(_onChangeHookGenerator);

var _PropTypes = require('../../validators/common/PropTypes');

var _url = require('../../../util/url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Light wrapper around React-Bootstrap's FormControl class.
 * Best suited for generating atomic input elements.
 * @extends {Component}
 */
var FormControlComponent = function FormControlComponent(_ref) {
  var field = _ref.field,
      children = _ref.children,
      formControlBsClass = _ref.formControlBsClass,
      formControlComponentClass = _ref.formControlComponentClass,
      formControlId = _ref.formControlId,
      formControlType = _ref.formControlType,
      onChangeHook = _ref.onChangeHook,
      formControlMinimum = _ref.formControlMinimum,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      placeholder = _ref.placeholder,
      className = _ref.className,
      maxLength = _ref.maxLength;

  if (onChangeHook) {
    return _react2.default.createElement(
      _reactBootstrap.FormControl,
      _extends({}, (0, _reduxFormPropFilter2.default)(field), {
        onChange: (0, _onChangeHookGenerator2.default)(field.onChange, onChangeHook),
        bsClass: formControlBsClass,
        componentClass: formControlComponentClass,
        id: formControlId,
        type: formControlType,
        min: formControlMinimum,
        disabled: (0, _url2.default)('form') === 'read_only' || disabled
      }),
      children
    );
  }

  return _react2.default.createElement(
    _reactBootstrap.FormControl,
    _extends({}, (0, _reduxFormPropFilter2.default)(field), {
      bsClass: formControlBsClass,
      className: className,
      componentClass: formControlComponentClass,
      id: formControlId,
      type: formControlType,
      min: formControlMinimum,
      disabled: (0, _url2.default)('form') === 'read_only',
      placeholder: placeholder,
      maxLength: maxLength
    }),
    children
  );
};

FormControlComponent.propTypes = {
  field: _react2.default.PropTypes.object.isRequired,
  children: _PropTypes.REACT_CHILDREN,
  formControlBsClass: _react2.default.PropTypes.string,
  formControlComponentClass: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.element]),
  formControlId: _react2.default.PropTypes.string,
  formControlType: _react2.default.PropTypes.string,
  formControlMinimum: _react2.default.PropTypes.number,
  onChangeHook: _react2.default.PropTypes.func,
  defaultValue: _react2.default.PropTypes.string,
  disabled: _react2.default.PropTypes.bool,
  placeholder: _react2.default.PropTypes.string,
  className: _react2.default.PropTypes.string,
  maxLength: _react2.default.PropTypes.number
};

exports.default = FormControlComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/input/FormControlComponent.jsx
// module id = 407
// module chunks = 0